import Vue from 'vue'
import App from './App.vue'
import store from './store'
import router from './router.js'
import vuetify from './plugins/vuetify'
import "./plugins/vuetify-mask.js";
import "./assets/styles.scss";

Vue.config.productionTip = false

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
